export default __webpack_public_path__ + "static/media/Climate.fe6d28fe.png";